import { Link } from 'react-router';
import { cn } from '@/lib/utils';
import { LEGAL_PATHS } from './legal.config';

/** Links para os Termos e a Política. `newTab` abre em outra aba (cadastro/convite: não perde o formulário). */
export function LegalLinks({
  className,
  linkClassName,
  newTab,
  onNavigate,
}: {
  className?: string;
  linkClassName?: string;
  newTab?: boolean;
  onNavigate?: () => void;
}) {
  const extra = newTab ? { target: '_blank', rel: 'noopener noreferrer' } : {};
  const cls = cn('underline-offset-4 hover:underline focus-visible:underline', linkClassName);
  return (
    <nav aria-label="Documentos legais" className={cn('flex flex-wrap items-center gap-x-3 gap-y-1 text-xs', className)} data-testid="legal-links">
      <Link to={LEGAL_PATHS.terms} className={cls} onClick={onNavigate} {...extra}>
        Termos de Uso
      </Link>
      <span aria-hidden>·</span>
      <Link to={LEGAL_PATHS.privacy} className={cls} onClick={onNavigate} {...extra}>
        Política de Privacidade
      </Link>
    </nav>
  );
}
